const createSocketReissueCoordinator = ({ socket, jwtService, onRevoked }) => {
  let reissueExpected = false
  let freshTokenReady = false
  let disconnectObserved = !socket.connected
  let reconnectStarted = false
  let disconnectRequested = false
  const latestFenceByOperation = new Map()
  const latestSignalKey = { server: null, fresh: null }

  const normalizeSignal = payload => {
    const operationId = payload && payload.operationId ? String(payload.operationId) : null
    const fence = payload && Number(payload.fence)
    const validFence = Number.isSafeInteger(fence) ? fence : null
    return {
      operationId,
      fence: validFence,
      key: operationId && validFence != null ? `${operationId}:${validFence}` : null,
    }
  }

  const isSupersededSignal = signal => {
    if (!signal.operationId || signal.fence == null) return false
    const previous = latestFenceByOperation.get(signal.operationId)
    if (previous != null && signal.fence < previous) return true
    if (previous == null || signal.fence > previous) latestFenceByOperation.set(signal.operationId, signal.fence)
    return false
  }

  const isDuplicateSignal = (kind, signal) => {
    if (!signal.key) return false
    if (latestSignalKey[kind] === signal.key) return true
    latestSignalKey[kind] = signal.key
    return false
  }

  const reconnectIfReady = () => {
    if (!reissueExpected || !freshTokenReady || !disconnectObserved || reconnectStarted) return false
    reconnectStarted = true
    socket.connect()
    return true
  }

  const onServerReissued = payload => {
    const signal = normalizeSignal(payload)
    if (isSupersededSignal(signal) || isDuplicateSignal('server', signal)) return false
    if (!jwtService.isCallerFactorPending(payload)) return false
    reissueExpected = true
    reconnectIfReady()
    return true
  }

  const onFreshToken = payload => {
    const signal = normalizeSignal(payload)
    if (isSupersededSignal(signal) || isDuplicateSignal('fresh', signal)) return false
    freshTokenReady = true
    reissueExpected = true
    if (socket.connected) {
      if (!disconnectRequested) {
        socket.disconnect()
        disconnectRequested = true
      }
    } else {
      disconnectObserved = true
      disconnectRequested = false
      reconnectIfReady()
    }
    return true
  }

  const onDisconnect = () => {
    disconnectObserved = true
    disconnectRequested = false
    reconnectIfReady()
  }

  const onConnect = () => {
    reissueExpected = false
    freshTokenReady = false
    disconnectObserved = false
    reconnectStarted = false
    disconnectRequested = false
    latestSignalKey.server = null
    latestSignalKey.fresh = null
    latestFenceByOperation.clear()
  }

  const onServerRevoked = payload => {
    if (jwtService.isCallerFactorPending(payload)) return onServerReissued(payload)
    onRevoked(payload)
    return false
  }

  return {
    onServerReissued,
    onFreshToken,
    onConnect,
    onDisconnect,
    onServerRevoked,
    state: () => ({
      reissueExpected, freshTokenReady, disconnectObserved, reconnectStarted,
    }),
  }
}

export default createSocketReissueCoordinator
